/*
 * Ryan O'Dowd
 * 2025-07-08
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale}) => {
  return {
    container: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      gap: globalScale * 8,
    },
  };
};

export default getStyles;
